import { createTheme, globalTheme } from '@clds/component-theme';

const spacing = globalTheme.spacing;

export const theme = createTheme({
  header: {
    background: globalTheme.palette.surfaceAlt,
    padding: {
      top: spacing.xs,
      right: spacing.xs,
      bottom: spacing.xs,
      left: spacing.md,
    },
  },
  content: { background: globalTheme.palette.surface, padding: spacing.md, maxWidth: '950px' },
  footer: {
    background: globalTheme.palette.surface,
    padding: spacing.md,
  },
  border: {
    color: globalTheme.palette.secondary,
  },
  saveModal: {
    minWidth: '380px',
  },
});
